import { render, staticRenderFns } from "./aside-news-svg.vue?vue&type=template&id=5aaa28c4&scoped=true"
import script from "./aside-news-svg.vue?vue&type=script&lang=js"
export * from "./aside-news-svg.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aaa28c4",
  null
  
)

export default component.exports